
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.906 4C8.31 4 3.97 8.5 3.97 8.5l1.437 1.375S9.082 6 15.906 6c2.13 0 3.973.582 5.469 1.313C19.425 7.995 18 9.823 18 12c0 2.75 2.25 5 5 5s5-2.25 5-5c0-1.242-.46-2.371-1.219-3.25 0 0-.09-.055-.093-.063-.215-.238-.43-.492-.688-.687-1.512-1.336-5.148-4-10.094-4zM23 9c.602 0 1.16.172 1.625.469.441.383.688.625.688.625.425.52.687 1.176.687 1.906 0 1.668-1.332 3-3 3s-3-1.332-3-3 1.332-3 3-3zM9 15c-2.75 0-5 2.25-5 5 0 1.242.46 2.371 1.219 3.25 0 0 .09.055.093.063.153.167.297.355.47.5.1.093.085.07.218.187.07.055.145.105.219.156C7.829 25.536 11.336 28 16.094 28c7.597 0 11.937-4.5 11.937-4.5l-1.437-1.375S22.918 26 16.094 26c-2.13 0-3.973-.582-5.469-1.313C12.575 24.005 14 22.177 14 20c0-2.75-2.25-5-5-5zm0 2c1.668 0 3 1.332 3 3a2.986 2.986 0 01-4.594 2.531c-.008-.004-.023.004-.031 0-.031-.027-.031-.004-.063-.031-.382-.34-.625-.594-.625-.594A2.987 2.987 0 016 20c0-1.668 1.332-3 3-3z"}})])
          )
        }
      }
    